module.exports = __webpack_public_path__ + "static/playing.a9494310.gif";